<template>
  <v-row justify="center">
    <v-dialog v-model="openDialog" persistent max-width="600">
      <!-- <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Open Dialog
        </v-btn>
      </template> -->
      <v-card>
        <v-card-title> {{ text }} </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="dialogAction(false)"> No </v-btn>
          <v-btn color="error darken-1" text @click="dialogAction(true)"> Yes </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'Dialog',
  props: ['dialog', 'text'],
  data: () => ({
    openDialog: false,
  }),
  watch: {
    dialog: function(newVal, oldVal) {
      this.openDialog = newVal
    },
  },
  methods: {
    dialogAction(action) {
      this.$emit('close', action)
    },
  },
}
</script>
